import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function addEmailTemplate(emailTemplate) {
	const url = `/${ADMIN_PREFIX}/addEmailTemplates`;
	return postApi(url, emailTemplate);
}
